// QuestionCard.jsx
import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Edit, Trash2 } from 'lucide-react';
import * as S from './question.style';

const QuestionCard = ({ question, level = 0 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const hasSubQuestions = question?.subQuestions && question.subQuestions.length > 0;

  return (
    <S.QuestionCardWrapper level={level}>
      <S.QuestionHeader onClick={toggleExpand}>
        <S.HeaderLeft>
          {(hasSubQuestions || question?.type === 'mcq') &&
            (isExpanded ? (
              <ChevronDown size={20} className="transition-transform duration-200" />
            ) : (
              <ChevronRight size={20} className="transition-transform duration-200" />
            ))}
          <S.QuestionType>{question?.type?.toUpperCase()}</S.QuestionType>
          <S.QuestionTitle>{question?.question}</S.QuestionTitle>
        </S.HeaderLeft>
        <S.ActionButtons>
          <S.IconButton onClick={(e) => e.stopPropagation()}>
            <Edit size={18} />
          </S.IconButton>
          <S.IconButton onClick={(e) => e.stopPropagation()}>
            <Trash2 size={18} />
          </S.IconButton>
        </S.ActionButtons>
      </S.QuestionHeader>

      {isExpanded && (
        <>
          <S.QuestionContent>
            {question?.type === 'text' ? (
              <S.AnswerSection>
                <S.Label>Answer:</S.Label>
                <S.AnswerText>{question?.answer}</S.AnswerText>
              </S.AnswerSection>
            ) : (
              <S.MCQSection>
                <S.Label>Options:</S.Label>
                <S.OptionsList>
                  {question?.options?.map((opt, idx) => (
                    <S.OptionItem key={idx} isCorrect={opt === question?.answer}>
                      <S.OptionNumber>{idx + 1}.</S.OptionNumber>
                      <S.OptionText>{opt}</S.OptionText>
                      {opt === question?.answer && <S.CorrectBadge>Correct Answer</S.CorrectBadge>}
                    </S.OptionItem>
                  ))}
                </S.OptionsList>
              </S.MCQSection>
            )}
          </S.QuestionContent>

          {hasSubQuestions && (
            <S.SubQuestionsWrapper>
              {question.subQuestions.map((subQuestion, index) => (
                <QuestionCard
                  key={subQuestion.id || index}
                  question={subQuestion}
                  level={level + 1}
                />
              ))}
            </S.SubQuestionsWrapper>
          )}
        </>
      )}
    </S.QuestionCardWrapper>
  );
};

// Example usage in parent component:
const QuestionsContainer = () => {
  const questions = [
    {
      id: 1,
      type: 'text',
      question: 'What is a duplex property?',
      answer: 'A duplex is a multi-family home that has two units in one building.',
      subQuestions: [
        {
          id: 2,
          type: 'mcq',
          question: 'Which of these is typically found in a duplex?',
          options: [
            'Separate entrances',
            'Shared walls',
            'Individual utilities',
            'All of the above',
          ],
          answer: 'All of the above',
          subQuestions: [
            {
              id: 3,
              type: 'text',
              question: 'What are the benefits of separate entrances?',
              answer: 'Separate entrances provide privacy and independence for tenants.',
            },
          ],
        },
      ],
    },
  ];

  return (
    <div>
      {questions.map((question) => (
        <QuestionCard key={question.id} question={question} />
      ))}
    </div>
  );
};

export default QuestionsContainer;
